
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-chance",
      function () {
        return require("private-next-pages/buying-chance/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buying-chance"])
      });
    }
  